/**
 * Testi statici dell'interfaccia (UI labels).
 * Per contenuti editabili → content/*.md
 */
export const LABELS = {
  nav: {
    home: 'Iniziativa',
    calendario: 'Calendario',
    faq: 'FAQ',
    menuApri: 'Apri menu',
    menuChiudi: 'Chiudi menu',
    mainNav: 'Navigazione principale',
    mobileMenu: 'Menu mobile',
    skipLink: 'Vai al contenuto principale',
  },
  menu: {
    titoloSezione: 'Menu della Serata',
    vuoto: 'Menu non ancora disponibile.',
  },
  attivita: {
    titoloSezione: 'Attività & Sport',
  },
  eventiSportivi: {
    titoloSezione: 'Eventi Sportivi in Programma',
    altroAncora: 'E Altro Ancora',
  },
  whatsapp: {
    titoloSezione: 'RIMANI AGGIORNATO!',
    cta: 'Iscriviti al Canale',
    ariaLink: 'Apri il canale WhatsApp del Terzo Tempo (link esterno)',
  },
  faq: {
    titoloSezione: 'Le Vostre Domande (FAQ)',
    altredomande: 'Hai altre domande? Scrivi a',
    emailContatto: 'info@terzotempogalgiana.it',
  },
  pausaEstiva: {
    titolo: 'Il Progetto "Terzo Tempo" è in pausa per l\'estate.',
    sottotitolo: 'Ci vediamo a settembre con tante novità!',
    invito: 'Nel frattempo puoi navigare il sito per scoprire l\'iniziativa.',
    ariaLabel: 'Avviso: pausa estiva del Progetto Terzo Tempo',
  },
  footer: {
    navLabel: 'Link social',
  },
  calendario: {
    titoloSezione: 'Calendario',
    descrizione: "Qui trovi l'elenco dei sabati in cui l'Oratorio è aperto. Scopri cosa è in programma ogni settimana e clicca sulla data per tutti i dettagli della serata.",
    prossimi: 'Prossimi Appuntamenti',
    breadcrumbHome: 'Home',
    tabLabel: 'Seleziona vista calendario',
    tabFuturi: 'Prossime Serate',
    tabArchivio: 'Archivio',
    vuotoFuturi: 'Nessun evento in programma',
    vuotoFuturiSub: 'Torna presto per aggiornamenti!',
    vuotoArchivio: 'Nessuna serata in archivio.',
    legenda: {
      titolo: 'Legenda Stati',
      attiva: { label: 'CONFERMATO', desc: 'Il sabato è attivo e i dettagli sono confermati.' },
      inAggiornamento: { label: 'IN AGGIORNAMENTO', desc: 'Il sabato è attivo ma alcune informazioni sono ancora in aggiornamento.' },
      nonAttivo: { label: 'ANNULLATO', desc: "L'iniziativa non è prevista in questa data." },
    },
  },
  evento: {
    doveValore: 'Oratorio di Galgiana',
    tornaCalendario: 'Torna al Calendario',
    navHome: 'Home',
    navCalendario: 'Calendario',
    cosaTiAspetta: 'Cosa ti aspetta',
    titoloProiezioneSportiva: 'Proiezione Sportiva',
    titoloSpaziDisponibili: 'Spazi Disponibili',
    titoloCiboBevande: 'Cibo & Bevande',
    titoloNoteOrganizzative: 'Note Organizzative',
    condividiSerata: 'Condividi Questa Serata',
    nessunProiezione: 'Nessuna proiezione in programma per questa serata.',
    proiezioneDettagli: 'Dettagli in aggiornamento',
    proiezioneDescrizione: 'Diretta su maxischermo con audio garantito e atmosfera da stadio!',
    proiezionePlaceholderAlt: 'Evento sportivo non ancora definito',
  },
} as const;